export const INFINITE_STR_DATE = "2099-12-31";
export const noDate = () => ({
  type: "noDate"
});
export const givenDate = date => ({
  type: "givenDate",
  date: date
});
export const optionalDate = date => date === INFINITE_STR_DATE ? noDate() : givenDate(date);